import logger from "../../../utils/LoggerFrontend";

export async function notifyAssistantCampaignStartedSlack({
  Actions,
  userName,
  userId,
  email,
  orgaName,
  orgaId,
  campaignId
}) {
  const channel = email.includes("talentbait.com")
    ? "#assistant-campaign-creation-test"
    : "#assistant-campaign-creation";

  const cleanUserName = `<https://app.talentbait.de/admin/users/${userId}|${userName}>`;

  const message = `
🛠️ *Assistant Campaign In Progress*

👤 *User:* ${cleanUserName}  
🏢 *Organization:* <https://internal.talentbait.de/admin/organizations/${orgaId}|${orgaName}>  
📢 *Draft Campaign:* <https://app.talentbait.de/assistant/preview/${campaignId}|View Campaign>

The user has started creating a campaign using the assistant, but it’s not completed yet. Let's track this one closely. ⚠️
  `;

  logger.log("AssistantCampaignStartedSlack", "slack channel", { channel });
  logger.log("AssistantCampaignStartedSlack", "message composed", { message });

  Actions.sendSlackMessage({ message, channel });
}
